import { render, staticRenderFns } from "./logoutPage.vue?vue&type=template&id=88f12f34&scoped=true&"
import script from "./logoutPage.vue?vue&type=script&lang=js&"
export * from "./logoutPage.vue?vue&type=script&lang=js&"
import style0 from "./logoutPage.vue?vue&type=style&index=0&id=88f12f34&prod&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f12f34",
  null
  
)

export default component.exports